import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';

const RowGrid: React.FC<
  GridProps & { border?: boolean, borderColor?: string },
> = withStyles((theme) => ({
  root: {
    borderTop: (props) =>
      `2px dotted ${props.borderColor || theme.palette.divider}`,
    borderBottom: (props) =>
      props.border
        ? `2px dotted ${props.borderColor || theme.palette.divider}`
        : undefined,
    flexWrap: 'nowrap',
    padding: '20px 33px',
    [theme.breakpoints.down(768)]: {
      flexWrap: 'wrap',
      padding: '16px 0',
    },
  },
}))(({ border, borderColor, ...props }) => <Grid {...props} />);

export default RowGrid;
